import React from 'react';
import { PollWrapper } from './styles';
/**
 * Poll 컴포넌트 렌더러
 * Poll 컴포넌트가 이관되기 전까지 임시로 사용
 */ var PollRenderer = function(param) {
    var poll = param.poll, onVote = param.onVote;
    if (!poll) return null;
    // TODO: Poll 컴포넌트 이관 후 실제 렌더링 구현
    console.warn('Poll component not yet migrated to content-ui');
    // 임시 렌더링 (Poll 컴포넌트 이관 전까지)
    return /*#__PURE__*/ React.createElement(PollWrapper, {
        className: "poll-container"
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            padding: '1rem',
            border: '1px solid #e5e7eb',
            borderRadius: '0.75rem',
            backgroundColor: '#f9fafb'
        }
    }, /*#__PURE__*/ React.createElement("p", {
        style: {
            fontWeight: 600,
            marginBottom: '0.5rem'
        }
    }, poll.question), /*#__PURE__*/ React.createElement("p", {
        style: {
            fontSize: '0.875rem',
            color: '#6b7280'
        }
    }, "투표 기능은 Poll 컴포넌트 이관 후 사용 가능합니다.")));
/* Poll 컴포넌트 이관 후 사용할 코드
  // API 응답 구조 디버깅
  console.log('Poll data in ContentBase:', poll);

  // 속성 안전하게 접근하는 헬퍼 함수들
  const getOptionId = (opt: any): string => {
    return typeof opt === 'object' && opt !== null
      ? (opt.optionId || opt.id || '')
      : '';
  };

  const getExpiresAt = (): Date | undefined => {
    if (poll.expiresAt) return poll.expiresAt;
    if (typeof poll === 'object' && poll !== null && 'endsAt' in poll) {
      const endsAt = (poll as any).endsAt;
      return endsAt ? new Date(endsAt) : undefined;
    }
    return undefined;
  };

  const getUserVoted = (): string | undefined => {
    if (poll.userVoted) return poll.userVoted;
    if (typeof poll === 'object' && poll !== null && 'chosenOptionId' in poll) {
      return (poll as any).chosenOptionId;
    }
    return undefined;
  };

  // Poll 컴포넌트의 타입에 맞는 initialApiData 생성
  const initialApiData = {
    pollId: typeof poll === 'object' && poll !== null ? ((poll as any).pollId || 'poll') : 'poll',
    question: poll.question || '투표',
    options: Array.isArray(poll.options) 
      ? poll.options.map(opt => ({
          optionId: getOptionId(opt),
          text: opt.text || '',
          votes: typeof opt.votes === 'string' ? opt.votes : String(opt.votes || 0)
        }))
      : [],
    totalVotes: typeof poll.totalVotes === 'string' ? poll.totalVotes : String(poll.totalVotes || 0),
    durationMinutes: typeof poll === 'object' && poll !== null ? ((poll as any).durationMinutes || 1440) : 1440,
    endsAt: getExpiresAt()?.toISOString(),
    userVotedOptionId: getUserVoted(),
    isExpired: typeof poll === 'object' && poll !== null ? ((poll as any).isExpired || false) : false
  };

  // Poll 컴포넌트에 전달할 props
  const pollProps = {
    initialApiData,
    onVote,
    className: 'poll-component'
  };

  console.log('Final Poll props for molecules/social/Poll:', pollProps);

  return (
    <PollWrapper className="poll-container">
      <Poll {...pollProps} />
    </PollWrapper>
  );
  */ };
export default PollRenderer;
